(() => {
  'use strict';
  // Ditto: the product view (the large square), the large picture with zoom, and the bag, on Shopify.
  // The markup comes from Shopify (sections/ditto-product.liquid and the ditto-cart section), so this
  // script only reads and wires the DOM. Same behaviour as the prototype (concepts/src/shop.js), with
  // Shopify's Cart API and real product addresses instead of the demo bag and #/products/… links.
  const $ = id => document.getElementById(id);
  const root = window.Shopify?.routes?.root || '/';
  const view = $('product-dialog');            // absent on a product page: there the piece is the page
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const node = (tag, className, text) => { const el = document.createElement(tag); if (className) el.className = className; if (text !== undefined) el.textContent = text; return el; };
  let productOpener = null, cartOpener = null, inBag = new Set();

  // A cloned cutout needs its own clip-path ids, or it would point at the original's.
  function cloneCutout(svg,prefix){
    const clone=svg.cloneNode(true);
    clone.querySelectorAll('[id]').forEach(el=>{
      const old=el.id,next=`${prefix}-${old}`;el.id=next;
      clone.querySelectorAll('[clip-path]').forEach(target=>{if(target.getAttribute('clip-path')===`url(#${old})`)target.setAttribute('clip-path',`url(#${next})`);});
    });
    clone.setAttribute('aria-hidden','true');
    return clone;
  }

  // ---- The bag -----------------------------------------------------------------------------------
  // Every change asks Shopify for the bag already rendered ("sections"), and the count and the
  // "In your bag" state come from /cart.js.
  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = `(${count})`; });
    document.querySelectorAll('.cart-items-count').forEach(el => { el.textContent = count ? `(${count})` : ''; });
  }
  async function syncCart() {
    try {
      const cart = await (await fetch(`${root}cart.js`, {headers: {Accept: 'application/json'}})).json();
      inBag = new Set(cart.items.map(item => String(item.variant_id)));
      setCount(cart.item_count);
    } catch (_) { /* The page still works; the count updates on the next change. */ }
  }
  function swapBag(html) {
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-body');
    const current = $('cart-body');
    if (fresh && current) current.replaceWith(fresh);
  }
  async function bagRequest(path, body) {
    const response = await fetch(`${root}${path}`, {
      method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({...body, sections: 'ditto-cart', sections_url: location.pathname})
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong. Try again.');
    swapBag(data.sections?.['ditto-cart']);
    await syncCart();
    if (view?.open) updateVariant();
    return data;
  }
  async function refreshBag() {
    try {
      const data = await (await fetch(`${location.pathname}?sections=ditto-cart`)).json();
      swapBag(data['ditto-cart']);
    } catch (_) { /* Keep what the page has. */ }
  }
  function bagStatus(text) { const status = $('cart-status'); if (status) status.textContent = text; }
  async function openCart({over = false, returnTo = document.activeElement} = {}) {
    const dialog = $('cart-dialog');
    if (!dialog) { $('cart-body')?.scrollIntoView({behavior: reducedMotion.matches ? 'auto' : 'smooth'}); return; }   // the /cart page
    cartOpener = returnTo;
    if (view?.open && !over) view.close();
    if (!dialog.open) dialog.showModal();
    if (!over) await refreshBag();
  }

  // ---- The product view ------------------------------------------------------------------------
  const productForm = () => $('product-form');
  // Size buttons: sold-out sizes are greyed out and cannot be chosen. F/W asks for a size first.
  function updateVariant() {
    const form = productForm(); if (!form) return;
    const choices = [...form.querySelectorAll('[name="id"]')];
    const chosen = choices.find(c => c.type === 'hidden' || c.checked);
    const soldOut = choices.every(c => c.disabled || c.hasAttribute('data-sold-out'));
    const already = Boolean(chosen) && inBag.has(chosen.value);
    if (chosen) $('detail-price').textContent = chosen.dataset.price;
    $('add-button').disabled = soldOut || already;   // "Select size" stays pressable: it points to the sizes
    $('add-button').classList.toggle('is-waiting', !soldOut && !chosen);
    $('add-button').textContent = soldOut ? (form.dataset.world === 'fw' ? 'Sold out' : 'Sold') : !chosen ? 'Select size' : already ? 'In your bag' : 'Add to bag';
    $('detail-cart').hidden = !already;
  }
  // Cutout slides: a PNG often carries transparent air around the garment (Finder's Remove Background
  // keeps the photo's whole canvas), which would leave the piece small in the square. The garment's real
  // edges are measured once on a small canvas (the CDN allows it) and the picture is sized and centred so
  // those edges meet the slide's content box, as if the file had been cropped tight. Same idea as the rack.
  function fitSlide(image) {
    if (!image.dataset.bw) return;
    const slide = image.parentElement, cs = getComputedStyle(slide);
    const padL = parseFloat(cs.paddingLeft), padT = parseFloat(cs.paddingTop);
    const boxW = slide.clientWidth - padL - parseFloat(cs.paddingRight), boxH = slide.clientHeight - padT - parseFloat(cs.paddingBottom);
    if (boxW <= 0 || boxH <= 0) return;
    const bx = +image.dataset.bx, by = +image.dataset.by, bw = +image.dataset.bw, bh = +image.dataset.bh;
    const scale = Math.min(boxW / (bw * image.naturalWidth), boxH / (bh * image.naturalHeight));
    const width = image.naturalWidth * scale, height = image.naturalHeight * scale;
    const left = padL + (boxW - bw * width) / 2 - bx * width, top = padT + (boxH - bh * height) / 2 - by * height;
    image.style.cssText = `position:absolute;left:${left.toFixed(1)}px;top:${top.toFixed(1)}px;width:${width.toFixed(1)}px;height:${height.toFixed(1)}px;max-width:none;object-fit:fill`;
  }
  function slideBounds(source, w, h) {
    const canvas = document.createElement('canvas'); canvas.width = w; canvas.height = h;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(source, 0, 0, w, h);
    const data = ctx.getImageData(0, 0, w, h).data;
    let x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      if (data[(y * w + x) * 4 + 3] > 24) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 < 0) return null;
    return { bx: (x0 / w).toFixed(4), by: (y0 / h).toFixed(4), bw: ((x1 - x0 + 1) / w).toFixed(4), bh: ((y1 - y0 + 1) / h).toFixed(4) };
  }
  function applySlide(image, edges) {
    if (!edges) return;
    image.dataset.bx = edges.bx; image.dataset.by = edges.by; image.dataset.bw = edges.bw; image.dataset.bh = edges.bh;
    fitSlide(image);
  }
  function trimSlide(image) {
    if (image.dataset.bw || !/\.png(\?|$)/i.test(image.currentSrc || image.src)) return;
    // Not loaded yet (a cached picture can report complete before it has a size): measure when it is.
    if (!image.naturalWidth) {
      if (image.dataset.waiting) return;
      image.dataset.waiting = '1';
      image.addEventListener('load', () => { delete image.dataset.waiting; trimSlide(image); }, { once: true });
      return;
    }
    const w = 160, h = Math.max(1, Math.round(image.naturalHeight / image.naturalWidth * w));
    try {
      applySlide(image, slideBounds(image, w, h));
    } catch (_) {
      // The canvas is tainted: the browser reused a copy fetched without CORS (a cache from an earlier
      // visit). Fetch it once more, with CORS and past the cache, and measure that copy.
      if (image.dataset.refetched) return;
      image.dataset.refetched = '1';
      fetch(image.currentSrc || image.src, { mode: 'cors', cache: 'reload' })
        .then(response => response.blob()).then(blob => createImageBitmap(blob))
        .then(bitmap => { try { applySlide(image, slideBounds(bitmap, w, h)); } finally { bitmap.close(); } })
        .catch(() => { /* a picture the browser will not let us read keeps its own framing */ });
    }
  }
  const refitSlides = new ResizeObserver(entries => entries.forEach(entry => entry.target.querySelectorAll('img').forEach(fitSlide)));
  function trimSlides() {
    document.querySelectorAll('.pv-slide img').forEach(image => {
      refitSlides.observe(image.parentElement);
      if (image.complete) trimSlide(image); else image.addEventListener('load', () => trimSlide(image), { once: true });
    });
  }
  function updateArrows() {
    const gallery = $('pv-gallery'); if (!gallery) return;
    const at = Math.round(gallery.scrollLeft / (gallery.clientWidth || 1)), last = gallery.children.length - 1;
    const scope = gallery.closest('.pv') || document;
    scope.querySelector('.pv-prev')?.toggleAttribute('disabled', at <= 0);
    scope.querySelector('.pv-next')?.toggleAttribute('disabled', at >= last);
  }
  // Opening a piece from the rack or the grid: Shopify renders the product section for that product,
  // and its #product-view goes into the dialog. The address becomes the product's own.
  async function openProduct(url, opener, {push = true} = {}) {
    if (!view) { location.href = url; return; }
    productOpener = opener || null;
    let fresh = null;
    try {
      const path = new URL(url, location.href).pathname;
      const html = await (await fetch(`${path}?section_id=ditto-product`)).text();
      fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('product-view');
    } catch (_) { /* fall through to the product page */ }
    if (!fresh) { location.href = url; return; }
    $('product-view').replaceChildren(...fresh.childNodes);
    if (push && new URL(url, location.href).pathname !== location.pathname) history.pushState({dittoProduct: url}, '', url);
    updateVariant();
    if (!view.open) view.showModal();
    $('product-view').scrollTop = 0; updateArrows(); trimSlides();
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-product-link]');
    if (!link || !view || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openProduct(link.href, link);
  });
  // Delegated on the document, so the same code serves the dialog and the product page.
  document.addEventListener('change', event => {
    if (event.target.closest('#product-view') && event.target.name === 'id') { $('add-feedback').textContent = ''; updateVariant(); }
    // A size picked in an add-on row arms that row's Add button.
    if (event.target.name?.startsWith('addon-')) {
      const button = event.target.closest('.addon').querySelector('.addon-add');
      button.dataset.add = event.target.value; button.disabled = false;
    }
  });
  document.addEventListener('scroll', event => { if (event.target.id === 'pv-gallery') updateArrows(); }, true);
  document.addEventListener('submit', async event => {
    if (!event.target.matches('#product-form')) return;   // not form.id: the size inputs are named "id" (Shopify's cart needs that) and shadow it
    event.preventDefault();
    const form = event.target, button = $('add-button');
    const chosen = [...form.querySelectorAll('[name="id"]')].find(c => c.type === 'hidden' || c.checked);
    if (!chosen) { form.querySelector('[name="id"]:not(:disabled)')?.focus(); $('add-feedback').textContent = 'Select a size first.'; return; }
    button.disabled = true; button.setAttribute('aria-busy', 'true');
    try {
      await bagRequest('cart/add.js', {items: [{id: Number(chosen.value), quantity: 1}]});
      $('add-feedback').textContent = 'Added to your bag.';
      openCart({over: true, returnTo: $('detail-cart')});   // the bag comes in over the piece, with add-ons
    } catch (error) {
      $('add-feedback').textContent = error.message;
      updateVariant();
    } finally { button.removeAttribute('aria-busy'); }
  });
  document.addEventListener('click', async event => {
    const inPiece = event.target.closest('#product-view');
    const step = inPiece && event.target.closest('[data-step]'), slide = inPiece && event.target.closest('.pv-slide');
    if (step) { const gallery = $('pv-gallery'); gallery.scrollBy({left: Number(step.dataset.step) * gallery.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth'}); return; }
    if (slide) { openZoom(slide); return; }
    if (inPiece && event.target.closest('#detail-cart')) { openCart({over: true}); return; }
    if (event.target.closest('#open-cart')) { openCart(); return; }
    const remove = event.target.closest('[data-remove]'), add = event.target.closest('[data-add]');
    if (remove || add) {
      try {
        if (remove) await bagRequest('cart/change.js', {id: remove.dataset.remove, quantity: 0});
        else if (add.dataset.add) await bagRequest('cart/add.js', {items: [{id: Number(add.dataset.add), quantity: 1}]});
        ($('cart-dialog')?.querySelector('.close') || $('cart-body'))?.focus?.();
      } catch (error) { bagStatus(error.message); }
    }
  });

  // Large view: click or tap zooms in at that point, the mouse or a finger moves around, pinch
  // zooms on touch screens, and the keyboard uses Enter, + / − and the arrow keys.
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const ZOOM = 2.5, MAX = 4;
  const zoom = {s:1,tx:0,ty:0};
  const pointers = new Map();
  let gesture = null, suppressClick = false;
  const clamp = (value,min,max) => Math.max(min,Math.min(max,value));
  function applyZoom(animate) {
    const content=$('zoom-content');
    const mx=(zoom.s-1)*content.offsetWidth/2,my=(zoom.s-1)*content.offsetHeight/2;
    zoom.tx=clamp(zoom.tx,-mx,mx);zoom.ty=clamp(zoom.ty,-my,my);
    $('zoom-dialog').classList.toggle('is-panning',!animate);
    $('zoom-dialog').classList.toggle('is-zoomed',zoom.s>1);
    content.style.transform=`translate(${zoom.tx}px,${zoom.ty}px) scale(${zoom.s})`;
    $('zoom-stage').setAttribute('aria-label',zoom.s>1?'Zoom out':'Zoom in');
    $('zoom-hint').textContent=zoom.s>1?(fine.matches?'Move to look around · click to zoom out':'Drag to look around · tap to zoom out'):(fine.matches?'Click to zoom':'Tap or pinch to zoom');
  }
  // Offset of a screen point from the centre of the (unzoomed) image.
  function offset(x,y){const r=$('zoom-stage').getBoundingClientRect();return {dx:x-(r.left+r.width/2),dy:y-(r.top+r.height/2)};}
  function zoomAt(scale,x,y){
    const {dx,dy}=x===undefined?{dx:0,dy:0}:offset(x,y);
    zoom.s=scale;zoom.tx=-dx*(scale-1);zoom.ty=-dy*(scale-1);
  }
  let zoomReturn=null;
  function openZoom(slide){
    zoomReturn=slide;
    const content=$('zoom-content');content.replaceChildren();
    const cutout=slide.querySelector('svg');   // only in the prototype; Shopify's cutout is a PNG
    if(cutout){
      const clone=cloneCutout(cutout,'zoom');clone.setAttribute('preserveAspectRatio','xMidYMid meet');content.append(clone);
    }else{
      const picture=slide.querySelector('img'),img=node('img');img.src=picture.currentSrc||picture.src;img.alt='';content.append(img);
    }
    $('zoom-title').textContent=$('product-title')?.textContent||'';
    zoom.s=1;zoom.tx=0;zoom.ty=0;
    $('zoom-dialog').showModal();applyZoom(false);$('zoom-stage').focus();
  }
  const stage=$('zoom-stage');
  stage.addEventListener('click',e=>{
    if(suppressClick){suppressClick=false;return;}
    if(zoom.s>1){zoom.s=1;zoom.tx=0;zoom.ty=0;}
    else if(e.detail===0)zoomAt(ZOOM);          // keyboard: zoom into the centre
    else zoomAt(ZOOM,e.clientX,e.clientY);
    applyZoom(true);
  });
  stage.addEventListener('pointerdown',e=>{
    if(e.pointerType==='mouse')return;
    stage.setPointerCapture?.(e.pointerId);
    pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
    if(pointers.size===2){const [a,b]=[...pointers.values()];gesture={pinch:true,dist:Math.hypot(a.x-b.x,a.y-b.y)||1,s:zoom.s};}
    else gesture={pinch:false,x:e.clientX,y:e.clientY,tx:zoom.tx,ty:zoom.ty,moved:false};
  });
  stage.addEventListener('pointermove',e=>{
    if(e.pointerType==='mouse'){
      if(zoom.s>1){const {dx,dy}=offset(e.clientX,e.clientY);zoom.tx=-dx*(zoom.s-1);zoom.ty=-dy*(zoom.s-1);applyZoom(false);}
      return;
    }
    if(!pointers.has(e.pointerId)||!gesture)return;
    pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
    if(gesture.pinch&&pointers.size>=2){
      const [a,b]=[...pointers.values()];
      zoom.s=clamp(gesture.s*Math.hypot(a.x-b.x,a.y-b.y)/gesture.dist,1,MAX);
      if(zoom.s===1){zoom.tx=0;zoom.ty=0;}
      applyZoom(false);
    }else if(!gesture.pinch){
      const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;
      if(Math.hypot(dx,dy)>8)gesture.moved=true;
      if(gesture.moved&&zoom.s>1){zoom.tx=gesture.tx+dx;zoom.ty=gesture.ty+dy;applyZoom(false);}
    }
  });
  function endPointer(e){
    if(!pointers.delete(e.pointerId)||!gesture)return;
    if(gesture.pinch||gesture.moved)suppressClick=true;
    if(pointers.size===1){const [p]=[...pointers.values()];gesture={pinch:false,x:p.x,y:p.y,tx:zoom.tx,ty:zoom.ty,moved:true};}
    else if(!pointers.size)gesture=null;
  }
  stage.addEventListener('pointerup',endPointer);stage.addEventListener('pointercancel',endPointer);
  stage.addEventListener('keydown',e=>{
    const step=60,keys={ArrowLeft:[step,0],ArrowRight:[-step,0],ArrowUp:[0,step],ArrowDown:[0,-step]};
    if(e.key==='+'||e.key==='='){zoom.s=clamp(zoom.s+.75,1,MAX);}
    else if(e.key==='-'){zoom.s=clamp(zoom.s-.75,1,MAX);if(zoom.s===1){zoom.tx=0;zoom.ty=0;}}
    else if(e.key in keys&&zoom.s>1){zoom.tx+=keys[e.key][0];zoom.ty+=keys[e.key][1];}
    else return;
    e.preventDefault();applyZoom(true);
  });
  window.addEventListener('resize',()=>{if($('zoom-dialog').open)applyZoom(false);});

  // ---- Dialogs, addresses and focus ----------------------------------------------------------------
  // Closing goes back to the address the page had before, so the browser's back button and × agree.
  view?.addEventListener('close', () => { if (history.state?.dittoProduct) history.back(); });
  window.addEventListener('popstate', () => {
    const url = history.state?.dittoProduct;
    if (url && view) openProduct(url, productOpener, {push: false});
    else if (view?.open) view.close();
  });
  const focusable = el => el?.isConnected && (!el.closest('dialog') || el.closest('dialog').open);
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', e => {
      if (e.target.closest('[data-close]')) { e.preventDefault(); dialog.close(); return; }
      if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); }
    });
    dialog.addEventListener('close', () => {
      if (dialog.id === 'zoom-dialog') { if (focusable(zoomReturn)) zoomReturn.focus(); return; }
      const target = dialog.id === 'cart-dialog' ? cartOpener : productOpener;
      if (focusable(target)) target.focus(); else if (focusable(productOpener)) productOpener.focus();
    });
  });
  window.addEventListener('pageshow', event => { if (event.persisted) { syncCart().then(updateVariant); refreshBag(); } });
  syncCart().then(updateVariant);
  updateArrows(); trimSlides();   // a product page has its gallery from the start
  window.DittoShop = {openProduct, openCart};
})();
